/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import React from 'react';
import proptypes from 'prop-types';
const { node, shape, string } = proptypes;

import { getGridClasses } from '../utils/ui';
import { LAUNDRY_GRID_BASE } from '../constants/index';

const LaundryProductsLayout = ({ children, grid = null, className = '', element = 'div' }) => {
  const gridClasses = getGridClasses(grid);
  const HTMLTag = typeof element === 'string' ? element : 'div';
  return (
    <HTMLTag
      className={`sui-relative sui-flex sui-flex-col sui-items-center ${LAUNDRY_GRID_BASE} ${gridClasses} ${className}`}
    >
      {children}
    </HTMLTag>
  );
};

LaundryProductsLayout.propTypes = {
  children: node.isRequired,
  grid: shape({}),
  className: string,
  element: string
};

export default LaundryProductsLayout;